import { TestLayerLabel, TestLayerValue, TestMode, TestModeLabel } from '@nrwl/common-lib';

export const RFC2544ConfigFieldMapping = {
  //setup
  ALIAS: 'alias',
  CUSTOMER: 'customer',
  TECHINICIAN: 'technician',
  CONTACT: 'contact',
  EMAIL: 'email',
  PHONE: 'phone',
  TECHINICIANID: 'technicianId',
  COMMENTS:'comments',
  TEST_MODE: 'mode',
  LAYER_TO_TEST: 'layer',
  IP_ADDRESS_TYPE: 'ip-address-type',
  STREAM_RATE_CONVENTION: 'unit-convention',
  MAX_TEST_DURATION: 'max-test-duration',
  THROUGHPUT: 'throughput',
  THROUGHPUT_DURATION: 'throughput-duration',
  THROUGHPUT_FRAME_LOSS_TOLERANCE: 'throughputFrameLossTolerance',
  THROUGHTPUT_STOP_OVERALL_TEST_ON_FAILURE: 'throughputStopOverallTestOnFailure',
  THROUGHPUT_STARTING_UTILIZATION: 'throughput-starting-utilization',
  THROUGHPUT_MIN_UTILIZATION: 'throughput-min-utilization',
  THROUGHPUT_MAX_UTILIZATION: 'throughput-max-utilization',
  THROUGHPUT_BANDWIDTH: 'throughput-bandwidth',
  FRAME_LOSS: 'frame-loss',
  FRAME_LOSS_DURATION: 'frame-loss-duration',
  FRAME_LOSS_MAX_LOSS_ALLOWED: 'frame-loss-max-loss-allowed',
  FRAME_LOSS_RUN_THORUGHPUT_FAILS: 'frame-loss-run-throughput-fails',
  FRAME_LOSS_REDUCE_UTILIZATION: 'frameLossReduceUtilization',
  LATENCY: 'latency',
  LATENCY_DURATION: 'latency-duration',
  LATENCY_NUM_OF_TRIALS: 'latency-num-of-trials',
  TARGET_LATENCY: 'target-Latency',
  TARGET_FDV: 'target-fdv',
  LATENCY_UTILIZATION: 'latency-utilization',
  BACK_TO_BACK: 'back-to-back',
  BACK_TO_BACK_TEST_TYPE: 'back-to-back-test-type',
  BACK_TO_BACK_MAX_LINE_RATE: 'back-to-back-max-line-rate',
  BACK_TO_BACK_REPETITIONS: 'back-To-Back-Repetitions',
  BACK_TO_BACK_TARGET_BURST_DURATION: 'back-to-back-target-burst-duration',
  CBS_COMMITTED_BURST_SIZE: 'cbs-committed-burst-size',
  CBS_KILO_BYTE_SIZE: 'cbs-kilo-byte-size',
  BACK_TO_BACK_BURST_RESOLUTION: 'back-to-back-burst-resolution',
  BACK_TO_BACK_MAX_TIME_RECEIVE_BURST: 'back-to-back-max-time-receive-burst',
  SELECTED_ORIGINATOR: 'selectedOriginator',
  SELECTED_DESTINATION: 'selectedDestination',
  RUN_TYPE: 'runType',
  SCHEDULER: 'scheduler',
  PERF_TEST_DURATION: 'perf-test-duration',

  //endpoints
  AGENT_TYPE: 'agentType',
  SUPPRESS_LOOP_COMMANDS: 'suppress-loop-commands',
  LOOPBACK_TYPE: 'loopback-type',
  VLAN_CONFIG: 'vlanConfig',
  NETWORK_OVERHEAD: 'network-overhead',
  ETHER_TYPE: 'ether-type',
  CVLAN_ETHER_TYPE: 'inner-ether-type',
  VLAN_ENABLED: 'vlanEnabled',
  SVLAN_ID: 'vlan-id',
  SVLAN_PRIORITY: 'vlan-priority',
  CVLAN_ID: 'inner-vlan-id',
  CVLAN_PRIORITY: 'inner-vlan-priority',
  VERIFY_PRIORITY: 'filter-on-priority',
  VLAN_DEFINED: 'vlanDefinedForEachService',
  ETHER_TYPE_DEFINED: 'etherTypeDefinedForEachService',
  SRC_TEST_IP_ADDRESS: 'srcTestIpAddress',
  SRC_IPV4_ADDRESS: 'test-ip',
  SRC_IPV6_ADDRESS: 'source-ipv6-address',
  SRC_SUBNET: 'test-subnet-mask',
  SRC_GATEWAY: 'test-gateway',
  DEST_TRANSMIT_INTERFACE: 'dest-tx-interface',
  DEST_DEFINED_ADDRESS: 'dest-definedAddress',
  DEST_EDIT_IP: 'destEditIP',
  DEST_EDIT_MAC: 'destEditMAC',
  DEST_IPV4_ADDRESS: 'destination-ip',
  DEST_IPV6_ADDRESS: 'dest-ipv6-address',
  REMOTE_VLAN_TAG: 'remote-tag-count',
  DEST_SHOW_IP_LAYER2: 'destShowIpWithLayer2',
  DEST_SHOW_MAC_LAYER3: 'destShowMacWithLayer3',
  DESTINATION_MAC: 'destination-mac',
  DEI_ENABLE: 'deiEnable',

  //stream
  STREAM: 'stream',
  CIR: 'cir-from-engine-a',
  VALID_FRAME_SIZE: 'validFrameSizes',
  FRAME_SIZE: 'frame-size-list',
  DSCP: 'dscp',
  TOS_DIFF_SERV: 'tos-diff-serv',
  STREAM_SLA_CIR: 'stream-sla-cir',
  TOS_DIFF_SERV_SELECTION: 'tos-diff-serv-selection',
  TOS: 'tos',
  MAX_BANDWIDTH: 'max_bandwidth',
  DEVICE_SELECTION_METHOD: 'device-selection-method',
  FRAME_LENGTH: 'frame-length',
  FLOW_LABEL: 'flow-label',
  TRAFFIC_CLASS: 'traffic-class',
  HOP_LIMIT: 'hop-limit',
  FRAME_SIZE_SINGLE: 'frameSizeSingle',
  FRAME_SIZE_DOUBLE: 'frameSizeDouble',
  VALID_FRAME_SIZE_SINGLE: 'validFrameSizesSingle',
  VALID_FRAME_SIZE_DOUBLE: 'validFrameSizesDouble'
};

export enum IPAddressLabel {
  IP_V4 = 'IPv4',
  IP_V6 = 'IPv6'
}

export enum IPAddressValue {
  IP_V4 = 'ipv4',
  IP_V6 = 'ipv6'
}

export enum streamRateConventionLabel {
  L1 = 'L1 Mbps (ULR)',
  L2 = 'L2 Mbps (IR)'
}

export enum streamRateConventionValue {
  L1 = 'l1-mbps',
  L2 = 'l2-mbps'
}

export enum vlanConfigLabel {
  UNTAGGED = 'Untagged',
  SINGLE_VLAN = 'Single VLAN',
  Q_IN_Q = 'Q-in-Q'
}

export enum vlanConfigValue {
  UNTAGGED = 'untagged',
  SINGLE_VLAN = 'tagged',
  Q_IN_Q = 'q_in_q'
}

export enum ETHER_TYPE_LABEL {
  ETHER_8100 = '8100',
  ETHER_88a8 = '88a8',
  ETHER_9100 = '9100'
}

export enum REMOTE_VLAN_TAG_COUNT_LABEL {
  NO_VLAN = 'No VLAN Tags',
  ONE_VLAN = '1 VLAN Tag',
  TWO_VLAN = '2 VLAN Tags'
}

export enum TRANSMIT_INTERFACE_VALUE {
  EQUIPMENT = 'equipment',
  NETWORK = 'network'
}

export enum TX_IMAGE {
  EQUIPMENT = 'images/equipment.png',
  NETWORK = 'images/network.png'
}

export enum TRANSMIT_INTERFACE_LABEL {
  EQUIPMENT = 'Equipment',
  NETWORK = 'Network'
}

export enum definedAddressValue {
  TEST_IP = 'testIP',
  MANAGEMENT_IP = 'managed',
  MANUAL = 'manual'
}

export enum definedAddressLabel {
  TEST_IP = 'Test IP',
  MANAGEMENT_IP = 'Management IP',
  MANUAL = 'Manual'
}

export const DEFINED_ADDRESS_TYPES = [
  { name: definedAddressLabel.TEST_IP, value: definedAddressValue.TEST_IP, enabled: true },
  {
    name: definedAddressLabel.MANAGEMENT_IP,
    value: definedAddressValue.MANAGEMENT_IP,
    enabled: true
  },
  { name: definedAddressLabel.MANUAL, value: definedAddressValue.MANUAL, enabled: true }
];

export const TRANSMIT_INTERFACE_TYPE = [
  { name: TRANSMIT_INTERFACE_LABEL.EQUIPMENT, value: TRANSMIT_INTERFACE_VALUE.EQUIPMENT },
  { name: TRANSMIT_INTERFACE_LABEL.NETWORK, value: TRANSMIT_INTERFACE_VALUE.NETWORK }
];

export const IP_ADDRESS_TYPE = [
  { name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 },
  { name: IPAddressLabel.IP_V6, value: IPAddressValue.IP_V6 }
];

export const STREAM_RATE_TYPE = [
  { name: streamRateConventionLabel.L2, value: streamRateConventionValue.L2 },
  { name: streamRateConventionLabel.L1, value: streamRateConventionValue.L1 }
];

export const VLAN_CONFIG_TYPE = [
  { name: vlanConfigLabel.UNTAGGED, value: vlanConfigValue.UNTAGGED },
  { name: vlanConfigLabel.SINGLE_VLAN, value: vlanConfigValue.SINGLE_VLAN },
  { name: vlanConfigLabel.Q_IN_Q, value: vlanConfigValue.Q_IN_Q }
];

export const REMOTE_VLAN_TAG_COUNT_TYPE = [
  { name: REMOTE_VLAN_TAG_COUNT_LABEL.NO_VLAN, value: 0 },
  { name: REMOTE_VLAN_TAG_COUNT_LABEL.ONE_VLAN, value: 1 },
  { name: REMOTE_VLAN_TAG_COUNT_LABEL.TWO_VLAN, value: 2 }
];

export const LOOPBACK_TYPE = [
  { name: 'JDSU QT-600 or QT-600-10', value: 'JDSU QT-600 or QT-600-10' }
];

export const CVLAN_ETHER_TYPE = [{ name: '8100', value: '8100' }];

export const CBS_KILO_BYTE_SIZES = [
  { name: 1024, value: 1024 },
  { name: 1000, value: 1000 }
];
export const CONFIRM_SELECTION = [
  { name: 'Yes', value: true },
  { name: 'No', value: false }
];

export const LOOP_UP_SELECTION = [
  { name: 'Yes', value: false },
  { name: 'No', value: true }
];

export const TOS_DIFF_SERV_SELECTION = [
  { name: 'DiffServ', value: 'DiffServ' },
  { name: 'ToS', value: 'ToS' }
];

export const LAYER_TYPES = [
  { name: TestLayerLabel.L2, value: TestLayerValue.L2 },
  { name: TestLayerLabel.L3, value: TestLayerValue.L3 }
];
export const ERROR_ON_OSS = [
  { name: 'Yes', value: true },
  { name: 'No', value: false }
];
export const KILOBYTE_TYPE = [
  { name: '1000', value: '1000' },
  { name: '1024', value: '1024' }
];
export const ACCESSRATE_TYPE = [
  { name: '10 Mbps', value: 'Mbps10' },
  { name: '100 Mbps', value: 'Mbps100' },
  { name: '1 Gbps', value: 'Mbps1000' },
  { name: '10 Gbps', value: 'Mbps10000' }
];
export const DSCP_CONFIG_TYPE = [
  {
    value: 'Best effort (0)',
    id: 0
  },
  {
    value: 'Class Selector 1 (8)',
    id: 32
  },
  {
    value: 'AF 11 (10)',
    id: 40
  },
  {
    value: 'AF 12 (12)',
    id: 48
  },
  {
    value: 'AF 13 (14)',
    id: 56
  },
  {
    value: 'Class Selector 2 (16)',
    id: 64
  },
  {
    value: 'AF 21 (18)',
    id: 72
  },
  {
    value: 'AF 22 (20)',
    id: 80
  },
  {
    value: 'AF 23 (22)',
    id: 88
  },
  {
    value: 'Class Selector 3 (24)',
    id: 96
  },
  {
    value: 'AF 31 (26)',
    id: 104
  },
  {
    value: 'AF 32 (28)',
    id: 112
  },
  {
    value: 'AF 33 (30)',
    id: 120
  },
  {
    value: 'Class Selector 4 (32)',
    id: 128
  },
  {
    value: 'AF 41 (34)',
    id: 136
  },
  {
    value: 'AF 42 (36)',
    id: 144
  },
  {
    value: 'AF 43 (38)',
    id: 152
  },
  {
    value: 'Class Selector 5 (40)',
    id: 160
  },
  {
    value: 'AF 51 (42)',
    id: 168
  },
  {
    value: 'AF 52 (52)',
    id: 176
  },
  {
    value: 'Exp. Forwarding (46)',
    id: 184
  },
  {
    value: 'Class Selector 6 (48)',
    id: 192
  },
  {
    value: 'Class Selector 7 (56)',
    id: 224
  }
];

export const SVLAN_PRIORITY_TYPE = [
  {
    value: 'Pri-0',
    id: 0
  },
  {
    value: 'Pri-1',
    id: 1
  },
  {
    value: 'Pri-2',
    id: 2
  },
  {
    value: 'Pri-3',
    id: 3
  },
  {
    value: 'Pri-4',
    id: 4
  },
  {
    value: 'Pri-5',
    id: 5
  },
  {
    value: 'Pri-6',
    id: 6
  },
  {
    value: 'Pri-7',
    id: 7
  }
];
export const CVLAN_PRIORITY_TYPE = [
  {
    value: 'Pri-0',
    id: 0
  },
  {
    value: 'Pri-1',
    id: 1
  },
  {
    value: 'Pri-2',
    id: 2
  },
  {
    value: 'Pri-3',
    id: 3
  },
  {
    value: 'Pri-4',
    id: 4
  },
  {
    value: 'Pri-5',
    id: 5
  },
  {
    value: 'Pri-6',
    id: 6
  },
  {
    value: 'Pri-7',
    id: 7
  }
];

export const SUBNET_MAP = {
  '1': '128.0.0.0',
  '2': '192.0.0.0',
  '3': '224.0.0.0',
  '4': '240.0.0.0',
  '5': '248.0.0.0',
  '6': '252.0.0.0',
  '7': '254.0.0.0',
  '8': '255.0.0.0',
  '9': '255.128.0.0',
  '10': '255.192.0.0',
  '11': '255.224.0.0',
  '12': '255.240.0.0',
  '13': '255.248.0.0',
  '14': '255.252.0.0',
  '15': '255.254.0.0',
  '16': '255.255.0.0',
  '17': '255.255.128.0',
  '18': '255.255.192.0',
  '19': '255.255.224.0',
  '20': '255.255.240.0',
  '21': '255.255.248.0',
  '22': '255.255.252.0',
  '23': '255.255.254.0',
  '24': '255.255.255.0',
  '25': '255.255.255.128',
  '26': '255.255.255.192',
  '27': '255.255.255.224',
  '28': '255.255.255.240',
  '29': '255.255.255.248',
  '30': '255.255.255.252',
  '31': '255.255.255.254',
  '32': '255.255.255.255'
};

export const PERF_TEST_DURATIONS = [
  { name: '1 minute', value: 60 },
  { name: '15 minutes', value: 900 },
  { name: '2 Hours', value: 7200 },
  { name: '24 Hours', value: 86400 },
  { name: 'User Defined', value: 'custom' }
];

export const SCHEDULER_ENDS_DURATIONS = [
  { name: '1 minute', value: 60 },
  { name: '5 minute', value: 300 },
  { name: '15 minutes', value: 900 },
  { name: '1 Hours', value: 3600 },
  { name: '2 Hours', value: 7200 },
  { name: '24 Hours', value: 86400 }
];

export const TEST_MODE_TYPES = [
  { name: TestModeLabel.LOOPBACK, value: TestMode.LOOPBACK },
  { name: TestModeLabel.MA_TO_MA, value: TestMode.UNIDIRECIONAL },
  { name: TestModeLabel.SEQUENTIAL, value: TestMode.SEQUENTIAL },
  { name: TestModeLabel.CONCURRENT, value: TestMode.CONCURRENT }
];

export const BANDWIDTH_ACCURACY = [1, 0.1, 0.01, 0.001];

export const BACK_TO_BACK_TEST_TYPES = [
  { name: 'Back To Back', value: 'b2b' },
  { name: 'CBS', value: 'cbs' }
];

export const MAX_LINE_RATE_LIST = [
  { name: '10Mbps', value: 10 },
  { name: '100Mbps', value: 100 },
  { name: '1000Mbps', value: 1000 },
  { name: '10000Mbps', value: 10000 }
];

export const IPV4_TABLE_HEADERS = [
  'streamDscp',
  'streamCir',
  'streamTosDiffServ',
  'streamFrameSize'
];

export const IPV6_TABLE_HEADERS = [
  'streamCir',
  'streamFlowLabel',
  'streamTrafficClass',
  'streamHopLimit',
  'streamFrameSize'
];

export const DEFAULT_STREAM = {
  'cir-from-engine-a': 10,
  'tos-diff-serv': false,
  dscp: 184,
  'frame-size-list': '64,128,256,512,1024,1280,1518',
  'flow-label': '1',
  'traffic-class': '00',
  'hop-limit': '64'
};
export const MAP_STREAM = {
  'cir-from-engine-a': 100,
  'tos-diff-serv': false,
  dscp: 184,
  'frame-size-list': '64,128,256,512,1024,1280,1518',
  'flow-label': '1',
  'traffic-class': '00',
  'hop-limit': '64'
};
